// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Next__Image = require("../../../reason/next/Next__Image.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ImageGridImage_image_graphql = require("../../../__generated__/ImageGridImage_image_graphql.bs.js");

let convertFragment = ImageGridImage_image_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ImageGridImage_image_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ImageGridImage_image_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ImageGridImage_image_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ImageGridImage_image_graphql.node, convertFragment, fRef);
}

let ImageFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ImageGridImage(props) {
  let __imageClassName = props.imageClassName;
  let imageVariant = props.imageVariant;
  let index = props.index;
  let imageClassName = __imageClassName !== undefined ? __imageClassName : "rounded object-cover max-w-full h-auto";
  let image = RescriptRelay_Fragment.useFragment(ImageGridImage_image_graphql.node, convertFragment, props.image);
  let match = imageVariant === "medium" ? [
      861,
      574,
      image.medium
    ] : (
      imageVariant === "small" ? [
          426,
          284,
          image.small
        ] : [
          1288,
          720,
          image.large
        ]
    );
  return JsxRuntime.jsx("button", {
    children: JsxRuntime.jsx(Next__Image.make, {
      src: match[2],
      width: match[0],
      height: match[1],
      unoptimized: true,
      alt: "",
      className: imageClassName
    }),
    className: TailwindMerge.twMerge([
      "flex items-stretch overflow-hidden rounded cursor-pointer transition-filter duration-150 ease-in hover:brightness-75 hover:ease-out",
      Stdlib_Option.getOr(props.className, "")
    ]),
    id: "image" + index.toString(),
    onClick: props.onPress
  }, "grid-image-" + index.toString());
}

let make = ImageGridImage;

exports.ImageFragment = ImageFragment;
exports.make = make;
/* Next__Image Not a pure module */
